<template>
  <div>
    <div class="columns is-variable is-1 is-mobile is-vcentered">
      <div class="column has-text-right">
        <b-field label="Jam Masuk">
          <b-timepicker
            v-model="startTimeValue"
            inline
            hour-format="24"
            required
          ></b-timepicker>
        </b-field>
      </div>
      <div class="column is-narrow pt-5 mt-5">
        <b-icon icon="minus-thick" size="is-small" type="is-grey"></b-icon>
      </div>
      <div class="column">
        <b-field label="Jam Pulang">
          <b-timepicker
            v-model="endTimeValue"
            inline
            hour-format="24"
            required
          ></b-timepicker>
        </b-field>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "CShiftForm",
  data() {
    return {
      startTimeValue: this.startTime,
      endTimeValue: this.endTime
    };
  },
  props: {
    startTime: Date,
    endTime: Date
  },
  methods: {
    onSubmit(callback) {
      callback(this.startTimeValue, this.endTimeValue);
    }
  },
  mounted() {
    this.$emit("setOnSubmit", this.onSubmit);
  }
};
</script>

<style scoped lang="scss">
.h-min-300 {
  min-height: 300px;
}

.h-auto {
  height: auto;
}
</style>
